<sdds-theme name="scania"></sdds-theme>

<app-header></app-header>
<div *ngIf=showLandingPage>
    <app-error></app-error>
</div>

<app-footer *ngIf="showLandingPage"></app-footer>